import { cn } from "@/lib/cn";
import { FlamingoMark } from "@/components/brand/FlamingoMark";

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  hint?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/** Centered icon + title + hint, used for empty lists and zero-states. */
export function EmptyState({
  icon,
  title,
  hint,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "relative flex flex-col items-center justify-center overflow-hidden px-6 py-14 text-center",
        className,
      )}
    >
      <FlamingoMark
        className="pointer-events-none absolute -bottom-6 right-2 -z-10"
        style={{ width: "10rem", opacity: 0.05 }}
      />
      {icon && (
        <div className="mb-5 flex size-16 items-center justify-center rounded-2xl border border-white/8 bg-white/[0.03] text-flamingo/80 shadow-glass">
          {icon}
        </div>
      )}
      <h3 className="font-display text-xl font-semibold text-white">{title}</h3>
      {hint && (
        <p className="mt-2 max-w-xs text-sm leading-relaxed text-white/50">
          {hint}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
